var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCubeBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.25 28.783 50.75 8.864a1.5 1.5 0 0 0-1.5 0l-34.5 19.919a1.5 1.5 0 0 0-.75 1.3v39.835a1.5 1.5 0 0 0 .75 1.3l34.5 19.919a1.5 1.5 0 0 0 1.5 0l34.5-19.919a1.5 1.5 0 0 0 .75-1.3V30.082a1.5 1.5 0 0 0-.75-1.299ZM50 11.9l30.79 17.772L50 47.448 19.21 29.672ZM17 31.859l31.5 18.187v37.193L17 69.052Zm34.5 55.38V50.046L83 31.859v37.193Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeBig);
export default __webpack_public_path__ + "static/media/cube-big.cbeb638a1ccd53d454e1437294d4a33d.svg";
export { ForwardRef as ReactComponent };